<template>
  <date-range-picker
    ref="picker"
    :locale-data="{format: 'dd-mmm-yyyy' }"
    :ranges="false"
    :minDate="minDate"
    :maxDate="maxDate"
    :singleDatePicker="false"
    :showDropdowns="true"
    :autoApply="true"
    v-model="dateRange"
    :linkedCalendars="true"
    opens="left"
    @select="selectDate"
  />
</template>
<script>
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DateRangePicker from "vue2-daterange-picker";

export default {
  data() {
    return {
      minDate: "",
      maxDate: "",
      dateRange: {},
    }
  },
  components: {
    DateRangePicker
  },
  methods: {
    selectDate(v) {
      this.$emit('select', v);
    },
  }
};
</script>